import React, { Component,Fragment } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter,MDBTableBody,MDBTable, MDBTableHead, MDBAlert, MDBSelect , MDBInput,MDBRow, MDBCol, MDBIcon   } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption } from "mdbreact";
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip, Divider   } from 'antd';
import Swal from 'sweetalert2/dist/sweetalert2.js'
import jsPDF from 'jspdf';  
import html2canvas from 'html2canvas';  
import domtoimage from 'dom-to-image';  
import { api, URL } from '../../api';


export default class Modaladdplan extends Component {
  selectRef = null;
    constructor(props) {
        super(props);
this.state = {
  modal: false,

  Curriculumopen_Full_Name_TH:'',
  emp:[],
  plan:[],

  Curriculumopen_ID:'',
  Course_YEAR:'',
  TEAM:'',
  week:'',
  title:'',
  ch:'',
  activity:'',
  teacherplanid:'',
  
  Univ_ID:'',
  Univ_NAME:'',
  Curriculumopen_Approve_Cu:'',
}

//this.handleChange = this.handleChange.bind(this);


this.handleSubmit = this.handleSubmit.bind(this);
this.toggle = this.toggle.bind(this);
this.onChange = this.onChange.bind(this);
this.handleChangeweek = this.handleChangeweek.bind(this);
this.handleChangetitle = this.handleChangetitle.bind(this);
this.handleChangech = this.handleChangech.bind(this);
this.handleChangeactivity = this.handleChangeactivity.bind(this);
this.getplan = this.getplan.bind(this);
}


toggle = () => {
  this.setState({
    modal: !this.state.modal,
    Course_ID:this.props.Course_ID
    
  });
 // this.props.getclassroom();
}

onChange(value) {
    //  console.log(`selected ${value}`);
    this.setState({ teacherplanid:value})
 }


 componentDidMount() {

  //const { id_send } = this.props.id_send
  //console.log(id_send);
  this.setState({ Curriculumopen_ID:this.props.Curriculumopen_ID})
  this.setState({ Curriculumopen_Full_Name_TH:this.props.Curriculumopen_Full_Name_TH})
  this.setState({ Course_YEAR:this.props.Course_YEAR})
  this.setState({ TEAM:this.props.Curriculumopen_TEAM})
  this.setState({ Univ_ID:this.props.Univ_ID})
  this.setState({ Univ_NAME:localStorage.getItem('Univ_NAME')})
  this.setState({ Curriculumopen_Approve_Cu:this.props.Curriculumopen_Approve_Cu})
  //this.setState({ Curriculumopen_User_UPDATE:localStorage.getItem('type2')})

  api.get('index/getteacheruniv/'+this.props.Univ_ID,
  //  Axios.get(`https://git.kpru.ac.th/FrontEnd_creditbank/index/getteacheruniv/`+localStorage.getItem('Univ_ID'),
    //  Axios.get(`https://mis.kpru.ac.th/api/EmployeeInOrg/000`,
            {headers: {
            // Authorization: 'Bearer ' + localStorage.getItem('myData')
            }
            })
            //  axios.defaults.headers.common['Authorization'] = `Bearer` + localStorage.getItem('myData') 
            .then(res => {
            // console.log(res.data[0].id)
            //  console.log(res.data)
          //  const Course = res.data.filter( ({ Course_Year }) => Course_Year >= this.state.year );
            //  console.log(Course)
               const emp = res.data;
                this.setState({ emp });
     }) 
     this.getplan();
  }


  handleChangeweek(event) {    this.setState({week: event.target.value});  }
  handleChangetitle(event) {    this.setState({title: event.target.value});  }
  handleChangech(event) {    this.setState({ch: event.target.value});  }
  handleChangeactivity(event) {    this.setState({activity: event.target.value});  }

  getplan() {
    setTimeout(() => {
       //ภายใน
       api.get('index/searchplan/'+this.props.Curriculumopen_ID)
       .then(res => {
       //  console.log(res);
       //  this.setState({ bankname: res.data, loading: false })
       let sortplan = res.data.sort((a, b) => {
        return a.Plan_Week - b.Plan_Week;
      });
         this.setState({ plan: sortplan})
       }) 
     }, 0);
  }

  clearValue = () => {
    this.selectRef.select.clearValue();
  };


  handleSubmit() {
    // alert('A name was submitted: ' + this.state.value);
    if (this.state.teacherplanid !=='' ) {

                    setTimeout(() => {

                  const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
                  datafrm.append("Plan_Curriculumopen_ID", this.state.Curriculumopen_ID);
                  datafrm.append("Plan_Course_YEAR", this.state.Course_YEAR);
                  datafrm.append("Plan_Team", this.state.TEAM);
                  datafrm.append("Plan_Week", this.state.week);
                  datafrm.append("Plan_Title", this.state.title);
                  datafrm.append("Plan_Ch", this.state.ch);
                  datafrm.append("Plan_Activity", this.state.activity);
                  datafrm.append("Plan_Teacherplanid", this.state.teacherplanid);
                  datafrm.append("Univ_ID", this.state.Univ_ID);
                  
                  api.post("index/AddPlan/",datafrm,{
                    headers: {
                        'content-type': 'multipart/form-data'
                    }
                  })

              .then(res => {
                //    console.log(res);
                    if (res.status === 200) {
                    //  alert("บันทึกสำเร็จ")
                              Swal.fire({
                                  title: 'บันทึกข้อมูลสำเร็จ',
                                  icon: 'success',
                                // showCancelButton: true,
                                  confirmButtonText: 'ตกลง',
                                // cancelButtonText: 'No, keep it'
                                }).then((result) => {

                                  this.getplan();
                                  
                                })
                            }
                    })
                  //  this.toggle()
                  //  this.props.getclassroom()
                  this.setState({ teacherplanid: ''});
                  this.setState({ week: ''});
                  this.setState({ title: ''});
                  this.setState({ ch: ''});
                  this.setState({ activity: ''});
                  this.getplan();
            }, 1000);
    }else{
            Swal.fire({
              title: 'กรุณาเพิ่มผู้สอน',
              text: "และบันทึกอีกครั้ง",
              icon: 'warning',
            // showCancelButton: true,
              confirmButtonText: 'ตกลง',
            // cancelButtonText: 'No, keep it'
            }).then((result) => {
            
            })

    }

//window.location.href = '/creditbank/Curriculum'
//this.props.updateat();
//this.getExpert()
  }

    render() {
      //  console.log(this.state.Course_ID)
        //  console.log(this.state.Curriculumopen_ID)
        //  console.log(this.state.Course_YEAR)
        //  console.log(this.state.TEAM)
        //  console.log(this.state.week)
        //  console.log(this.state.title)
        //  console.log(this.state.ch)
        //  console.log(this.state.activity)
      //    console.log(this.state.teacherplanid)
        // console.log(this.state.Curriculumopen_Date_START)
        // console.log(this.state.Curriculumopen_Date_END)
      let { sortedInfo, filteredInfo } = this.state;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};
        
        return (
            <>
            {/* <MDBBtn onClick={this.toggle} color="deep-purple" size="sm">รายชื่อยังไม่ได้ฉีดวัคซีน</MDBBtn> */}
            <MDBBtn onClick={this.toggle}  color="info" size="sm"> เพิ่มแผนการสอน </MDBBtn>
            <MDBModal isOpen={this.state.modal} toggle={this.toggle} size="fluid" >
              <MDBModalHeader toggle={this.toggle}> <MDBIcon fab icon="buffer" /> เพิ่มแผนการสอน</MDBModalHeader>
              <MDBModalBody>
               
               {this.props.Curriculumopen_Approve_Cu === '2'?<></>:<>
              <div id="pdfdiv">
              <MDBContainer>
                <MDBAlert color="primary">
                <h4 className="display-5 text-center">หลักสูตร : {this.state.Curriculumopen_Full_Name_TH}</h4>
                <h5 className="display-5 text-center">ภาคเรียน : {this.state.TEAM}</h5>
          
                </MDBAlert>
              </MDBContainer>
      <Divider orientation="left" plain> </Divider>
            <MDBRow>
                    <MDBCol sm="1"></MDBCol>
                    <MDBCol sm="2">
                     <div className="form-group">
                            <label htmlFor="example2">สัปดาห์ที่</label>
                            {/* <input type="text" id="example2" className="form-control form-control-md" value={this.state.Course_ID} onChange={this.handleChange4} /> */}
                            <div>
                            <select className="browser-default custom-select"  onChange={this.handleChangeweek.bind(this)}  icon="user" >
                                <option>เลือกสัปดาห์</option>
                                <option value="1">สัปดาห์ที่ 1</option>
                                <option value="2">สัปดาห์ที่ 2</option>
                                <option value="3">สัปดาห์ที่ 3</option>
                                <option value="4">สัปดาห์ที่ 4</option>
                                <option value="5">สัปดาห์ที่ 5</option>
                                <option value="6">สัปดาห์ที่ 6</option>
                                <option value="7">สัปดาห์ที่ 7</option>
                                <option value="8">สัปดาห์ที่ 8</option>
                                <option value="9">สัปดาห์ที่ 9</option>
                                <option value="10">สัปดาห์ที่ 10</option>
                                <option value="11">สัปดาห์ที่ 11</option>
                                <option value="12">สัปดาห์ที่ 12</option>
                                <option value="13">สัปดาห์ที่ 13</option>
                                <option value="14">สัปดาห์ที่ 14</option>
                                <option value="15">สัปดาห์ที่ 15</option>
                                <option value="16">สัปดาห์ที่ 16</option>
                                <option value="17">สัปดาห์ที่ 17</option>
                                <option value="18">สัปดาห์ที่ 18</option>
                                <option value="19">สัปดาห์ที่ 19</option>
                                <option value="20">สัปดาห์ที่ 20</option>
                            
                                </select> <br/>
                            </div>
                      </div>
                    </MDBCol>
                    <MDBCol sm="5">
                        <div className="form-group">
                            <label htmlFor="example2">หัวข้อ/รายละเอียด</label>
                            <input type="text" id="example2" className="form-control form-control-md" placeholder="ระบุ รายละเอียด" value={this.state.title} onChange={this.handleChangetitle} />
                        </div>
                    </MDBCol>
                    <MDBCol sm="3">
                        <div className="form-group">
                            <label htmlFor="example2">จำนวนชั่วโมง</label>
                            <input type="text" id="example2" className="form-control form-control-md" placeholder="จำนวนชั่วโมง" value={this.state.ch} onChange={this.handleChangech} />
                        </div>
                    </MDBCol>
          </MDBRow>

            <MDBRow>
                    <MDBCol sm="1"></MDBCol>
                    <MDBCol sm="5">
                        <div className="form-group">
                            <label htmlFor="example2">กิจกรรมการเรียนและสื่อที่ใช้ (ถ้ามี)</label>
                            <textarea
                            className="form-control"
                            id="exampleFormControlTextarea1"
                            placeholder="กิจกรรมการเรียนและสื่อที่ใช้"
                            value={this.state.activity} onChange={this.handleChangeactivity} 
                            rows="2"
                            />
                        </div>
                    </MDBCol>
                    <MDBCol sm="5">
                    <Fragment>
                          <div className="form-group">
                                <label htmlFor="example2">ผู้สอน/วิทยากร ผู้รับผิดชอบ</label>
                                {/* <input type="text" id="example2" className="form-control form-control-md" value={this.state.Course_ID} onChange={this.handleChange4} /> */}
                                <div>
                                    <Select
                                    showSearch
                                    style={{ width: '100%' }}
                                    placeholder="เลือกอาจารย์"
                                   
                                   // optionFilterProp="children"
                                    onChange={this.onChange}
                                    onFocus={this.onFocus}
                                    onBlur={this.onBlur}
                                    onSearch={this.onSearch}
                                    value={this.state.Teacher_Citizen_ID}
                                    filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    {/* <Option value="jack">Jack</Option>
                                    <Option value="lucy">Lucy</Option>
                                    <Option value="tom">Tom</Option> */}
                                {/* <option value="">ไม่ระบุ</option> */}
                                {this.state.emp.map((emp,index )  => 
                                <option value={emp.Teacher_Citizen_ID}>{emp.Teacher_NAME +" "+ emp.Teacher_LASTNAME}</option>
                                )}
                                </Select>
                              
                                </div>
                          </div>
                           </Fragment>   
                    </MDBCol>
                    <MDBCol sm="1">
                 
                    </MDBCol>
               </MDBRow>
                  
                    <div className="d-flex justify-content-center">
                    <p className="text-center"><MDBBtn color="primary" onClick={this.handleSubmit} >บันทึก</MDBBtn></p> 
                    </div>
                    <Divider orientation="left" plain> </Divider>
        
              </div>
              </>}
                            </MDBModalBody>

                   

                            <MDBContainer>
                            <h4 className="display-5 text-center">ตารางแผนการสอน</h4>
                            <MDBTable small responsiveMd>
                                <MDBTableHead color="grey darken-1" textWhite>
                                    <tr>
                                    <th>#</th>
                                    <th>สัปดาห์ที่</th>
                                    <th>หัวข้อ/รายละเอียด</th>
                                    <th>จำนวนชั่วโมง</th>
                                    <th>กิจกรรม</th>
                                    <th>ผู้สอน/วิทยากร</th>
                                    
                                    </tr>
                                </MDBTableHead>

                                <MDBTableBody>
                                {this.state.plan.map((plan,index) => {
                                  return  <tr>
                                    <td>{index+1}</td>
                                    <td>{plan.Plan_Week }</td>
                                    <td>{plan.Plan_Title }</td>
                                    <td>{plan.Plan_Ch }</td>
                                    <td>{plan.Plan_Activity }</td>
                                <td>{plan.Plan_Teacherplanid === '' ?<>ไม่ระบุผู้สอน</>:<>{plan.Teacher_NAME } {plan.Teacher_LASTNAME }</>}</td>
                                   
                                   
                                    </tr>
                                   })}  
                                </MDBTableBody>
                            </MDBTable>   

                            </MDBContainer>


              <MDBModalFooter size="fluid">
             
              <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn>
                
                {/* <MDBBtn color="primary" onClick={this.handleSubmit} >บันทึก</MDBBtn> */}
              </MDBModalFooter>
            </MDBModal>
          </>
          
        )
    }
}
